import { render, staticRenderFns } from "./widget-activity.vue?vue&type=template&id=4a88fb37&scoped=true"
import script from "./widget-activity.vue?vue&type=script&lang=ts"
export * from "./widget-activity.vue?vue&type=script&lang=ts"
import style0 from "./widget-activity.vue?vue&type=style&index=0&id=4a88fb37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88fb37",
  null
  
)

export default component.exports